import _defineProperty from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _toConsumableArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './Feedback.css';
import React, { useEffect, useState } from 'react';
import { canUseDOM, get } from '../../utils';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import ThumbButton from './components/ThumbButton';
import ReasonSelector from './components/ReasonSelector';
import { convertToAnalyticObject } from '../../utils/analytics';
var THUMB_UP_KEY = 'thumbUp';
var THUMB_DOWN_KEY = 'thumbDown';
var FEEDBACK_POSITIVE = 'postive';
var FEEDBACK_NEGATIVE = 'negative';
var STORAGE_NAME = 'pageFeedbacks';
var generateSessionId = function generateSessionId() {
  return "session-".concat(Math.random().toString(36).substring(2, 9));
};
export var Feedback = function Feedback(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);

  // 'Thank you for your feedback';
  var thankYouTitle = get(fields, 'data.item.positiveSubmitTitle.jss.value');
  // Thank you for your feedback.Help us improve'
  var thumbDownTitle = get(fields, 'data.item.negativeFeedbackTitle.jss.value');
  // Did you find this information helpful?
  var thumbUpTitle = get(fields, 'data.item.title.jss.value');
  // Thank you for your feedback! We will try to improve it
  var thumbDownFormTitle = get(fields, 'data.item.negativeSubmitTitle.jss.value');
  var submitButtonLabel = get(fields, 'data.item.buttonTitle.jss.value');
  var feedbackPlaceholderText = get(fields, 'data.item.placeholder.jss.value');
  var likeIconSvg = get(fields, 'data.item.likeIconSvg.jss.value');
  var dislikeIconSvg = get(fields, 'data.item.dislikeIconSvg.jss.value');
  var answerOptions = get(fields, 'data.item.answerOptions.items') || [];
  var answerOptionsEn = get(fields, 'data.itemEn.answerOptions.items') || [];
  var enableInputField = get(fields, 'data.item.enableInputField.jss.value');
  var _useState = useState(thumbUpTitle),
    _useState2 = _slicedToArray(_useState, 2),
    mainTitle = _useState2[0],
    setMainTitle = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    formVisible = _useState4[0],
    setFormVisible = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    otherReason = _useState6[0],
    setOtherReason = _useState6[1];
  var _useState7 = useState({
      key: ''
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    feedbackData = _useState8[0],
    setFeedbackData = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    feedbackReasons = _useState10[0],
    setFeedbackReasons = _useState10[1];
  var _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    feedbackInput = _useState12[0],
    setFeedbackInput = _useState12[1];
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    feedbackTypeExists = _useState14[0],
    setFeedbackTypeExists = _useState14[1];
  var _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    sessionId = _useState16[0],
    setSessionId = _useState16[1];
  var _useState17 = useState(true),
    _useState18 = _slicedToArray(_useState17, 2),
    isDesktop = _useState18[0],
    setIsDesktop = _useState18[1];
  var pageOrigin = canUseDOM ? document.location && document.location.origin && document.location.origin : '';
  var pagePathname = canUseDOM ? document.location && document.location.pathname && document.location.pathname : '';
  var pageUrl = pageOrigin + pagePathname;
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var thumbButtons = [{
    id: THUMB_UP_KEY,
    icon: likeIconSvg
  }, {
    id: THUMB_DOWN_KEY,
    icon: dislikeIconSvg
  }];
  useEffect(function () {
    if (answerOptions && answerOptions.length) {
      var answerOptionsUpdated = _toConsumableArray(answerOptions);
      answerOptionsUpdated.map(function (el, index) {
        var title = get(el, 'title.jss.value');
        var lastItem = index === answerOptionsUpdated.length - 1;
        el.id = "".concat(title, "-").concat(index);
        el.active = false;
        el.showForm = false;
        if (lastItem && enableInputField) {
          el.showForm = true;
        }
        if (answerOptionsEn && answerOptionsEn.length) {
          var enTitle = get(answerOptionsEn[index], 'title.jss.value') || '';
          el.englishTitle = lastItem ? "".concat(enTitle, ":") : enTitle;
        }
      });
      setFeedbackReasons(answerOptionsUpdated);
    }
  }, []);
  useEffect(function () {
    var storedSessionId = generateSessionId();
    setSessionId(storedSessionId);
    var storedPageFeedbacks = JSON.parse(localStorage.getItem(STORAGE_NAME) || '{}');
    if (storedPageFeedbacks[pageUrl]) {
      var feedbackType = storedPageFeedbacks[pageUrl].feedbackType;
      if (feedbackType) {
        setFeedbackTypeExists(feedbackType);
        setFeedbackData(feedbackType === FEEDBACK_POSITIVE ? {
          key: THUMB_UP_KEY
        } : {
          key: THUMB_DOWN_KEY
        });
      }
    }
  }, []);
  var checkIsDesktop = function checkIsDesktop() {
    var conditionDesktop = canUseDOM && window.innerWidth >= 1024;
    setIsDesktop(conditionDesktop);
  };
  React.useEffect(function () {
    if (canUseDOM) {
      window.addEventListener('resize', checkIsDesktop);
      var interval = setInterval(checkIsDesktop, 1000);
      return function () {
        window.removeEventListener('resize', checkIsDesktop);
        clearInterval(interval);
      };
    }
  }, []);
  if (!fields.data.item) {
    return /*#__PURE__*/React.createElement("div", null);
  }
  if (!fields) {
    console.info('Feedback component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[Feedback component is empty: please provide datasource]");
    }
    return null;
  }
  var updateStorage = function updateStorage(feedbackText, feedbackType) {
    var feedbackData = {
      timestamp: new Date().toISOString(),
      sessionID: sessionId,
      feedbackText: feedbackText
    };
    var storedPageFeedbacks = JSON.parse(localStorage.getItem(STORAGE_NAME) || '{}');
    if (storedPageFeedbacks) {
      // Update the feedbacks object
      storedPageFeedbacks[pageUrl] = {
        feedbackType: feedbackType,
        feedback: feedbackData
      };
      localStorage.setItem(STORAGE_NAME, JSON.stringify(storedPageFeedbacks));
    } else {
      // create the feedbacks object
      localStorage.setItem(STORAGE_NAME, JSON.stringify(_defineProperty({}, pageUrl, {
        feedbackType: feedbackType,
        feedback: feedbackData
      })));
    }
  };
  var onSubmit = function onSubmit(event) {
    setMainTitle(thumbDownFormTitle);
    setFormVisible(false);
    setOtherReason(false);
    event.preventDefault();
    var chosenReasons = feedbackReasons && feedbackReasons.filter(function (el) {
      return el.active;
    }).map(function (el) {
      return el.englishTitle;
    });
    var chosenReasonsFormatted = "".concat(_toConsumableArray(chosenReasons).join(', ')).concat(feedbackInput);
    updateStorage(chosenReasonsFormatted, FEEDBACK_NEGATIVE);
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['submitButtonAnalytics'], params), chosenReasonsFormatted);
  };
  var onThumbUp = function onThumbUp() {
    if (feedbackData['key'] === '') {
      setFeedbackData({
        key: THUMB_UP_KEY
      });
      setMainTitle(thankYouTitle);
      updateStorage(THUMB_UP_KEY, FEEDBACK_POSITIVE);
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['likeButtonAnalytics'], params));
    }
  };
  var onThumbDown = function onThumbDown() {
    if (feedbackData['key'] === '') {
      setFeedbackData({
        key: THUMB_DOWN_KEY
      });
      setMainTitle(feedbackReasons && feedbackReasons.length > 0 ? thumbDownTitle : thumbDownFormTitle);
      setFormVisible(true);
      updateStorage(THUMB_DOWN_KEY, FEEDBACK_NEGATIVE);
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['dislikeButtonAnalytics'], params));
    }
  };
  var onReasonChoose = function onReasonChoose(key, showForm, title) {
    var feedbacksUpdated = _toConsumableArray(feedbackReasons);
    var titleEditted = title ? title.replace(':', '') : title;
    feedbacksUpdated.map(function (el) {
      if (el.id === key) {
        el.active = !el.active;
      }
    });
    if (showForm) {
      setOtherReason(!otherReason);
    }
    setFeedbackReasons(feedbacksUpdated);
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['reasonButtonAnalytics'], params), ": ".concat(titleEditted));
  };
  var isSubmitDisaled = otherReason ? !Boolean(feedbackInput.length) : feedbackReasons && !feedbackReasons.filter(function (el) {
    return el.active;
  }).length;
  var renderTitle = function renderTitle() {
    var title = feedbackTypeExists ? feedbackData['key'] === THUMB_DOWN_KEY ? thumbDownTitle : thankYouTitle : mainTitle;
    return title && /*#__PURE__*/React.createElement("span", {
      className: "feedback-module__title"
    }, title);
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "feedback-module"
  }, /*#__PURE__*/React.createElement("div", {
    className: "feedback-module__top"
  }, renderTitle(), /*#__PURE__*/React.createElement("div", {
    className: "feedback-module__thumbs"
  }, thumbButtons.map(function (el) {
    return /*#__PURE__*/React.createElement(ThumbButton, _extends({
      key: el.id,
      feedbackData: feedbackData['key'],
      handleClick: el.id === THUMB_DOWN_KEY ? onThumbDown : onThumbUp
    }, el));
  }))), formVisible && !feedbackTypeExists && /*#__PURE__*/React.createElement("form", {
    className: "feedback-module__form ".concat(otherReason ? 'input-mode' : ''),
    onSubmit: onSubmit
  }, feedbackReasons && feedbackReasons.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, otherReason ? /*#__PURE__*/React.createElement("div", {
    className: "feedback-module__reasons"
  }, feedbackReasons.map(function (reason, index) {
    return /*#__PURE__*/React.createElement(ReasonSelector, _extends({}, reason, {
      key: index,
      handleClick: onReasonChoose
    }));
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, feedbackReasons.map(function (reason, index) {
    return /*#__PURE__*/React.createElement(ReasonSelector, _extends({}, reason, {
      key: index,
      handleClick: onReasonChoose
    }));
  })), /*#__PURE__*/React.createElement("input", {
    tabIndex: -1,
    disabled: isSubmitDisaled,
    className: "feedback-module__submit ".concat(isSubmitDisaled ? 'buttonDisabled' : ''),
    type: "submit",
    value: submitButtonLabel
  })), otherReason && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
    className: "accessibility-hidden-text",
    htmlFor: "feedback-input",
    dangerouslySetInnerHTML: {
      __html: feedbackPlaceholderText ? feedbackPlaceholderText : ''
    }
  }), /*#__PURE__*/React.createElement("textarea", {
    id: "feedback-input",
    className: "feedback-module__explanation",
    name: "feedback",
    tabIndex: 0,
    onKeyDown: function onKeyDown(event) {
      if (isDesktop) {
        if (event.key === 'Enter') {
          event.preventDefault();
        }
      }
    },
    onChange: function onChange(event) {
      setFeedbackInput(event.target.value);
    },
    placeholder: feedbackPlaceholderText ? feedbackPlaceholderText : ''
  })))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
export var commonStyles = "ch5vc6r";
export var ltrStyles = "l792ww0";
export var rtlStyles = "r1rcglo0";
export default Feedback;